import { useForm } from 'react-hook-form';
import { Link, useSearchParams } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { Alert, Button, Card, CardContent, Input } from '@lms/ui';
import { api } from '@/lib/api';

interface ResetForm {
  password: string;
  passwordConfirmation: string;
}

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const email = params.get('email') ?? '';
  const { register, handleSubmit, watch } = useForm<ResetForm>();

  const mutation = useMutation({
    mutationFn: (values: ResetForm) =>
      api('/auth/reset-password', { method: 'POST', body: { ...values, token, email }, auth: false }),
  });

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface px-4">
      <Card className="w-full max-w-md">
        <div className="border-b border-dash-outline-variant px-6 py-5">
          <h1 className="text-xl font-semibold text-dash-primary">Restablecer contraseña</h1>
        </div>
        <CardContent className="px-6 py-5">
          {mutation.isSuccess ? (
            <Alert variant="success">
              Contraseña actualizada. <Link to="/login" className="font-medium underline">Inicia sesión</Link>
            </Alert>
          ) : (
            <>
              {mutation.error && <Alert variant="danger" className="mb-4">{(mutation.error as Error).message}</Alert>}
              <form onSubmit={handleSubmit((v) => mutation.mutate(v))} className="space-y-4">
                <Input label="Correo electrónico" type="email" value={email} readOnly disabled />
                <Input label="Nueva contraseña" type="password" autoComplete="new-password" {...register('password', { required: true, minLength: 8 })} />
                <Input
                  label="Confirmar contraseña"
                  type="password"
                  autoComplete="new-password"
                  {...register('passwordConfirmation', { required: true, validate: (v) => v === watch('password') || 'Las contraseñas no coinciden' })}
                />
                <Button type="submit" loading={mutation.isPending} className="w-full">Restablecer</Button>
              </form>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
